import { useCallback, useEffect, useMemo, useState } from 'react'
import { fetchAllAssignAgents, type AssignAgentRow } from '@/lib/utils/assignAgents'
import { getTicketAssignAgentListPath, isRegularTeamLead } from '@/lib/utils/roleHelper'
import { useAuthStore } from '@/store/auth'

export function useAssignAgentList(enabled: boolean) {
  const user = useAuthStore((s) => s.user)
  const path = useMemo(() => getTicketAssignAgentListPath(user), [user])
  const assignPool = isRegularTeamLead(user)
  const [agents, setAgents] = useState<AssignAgentRow[]>([])

  const reload = useCallback(async () => {
    if (!enabled) {
      setAgents([])
      return
    }
    try {
      setAgents(await fetchAllAssignAgents(path, { assignPool }))
    } catch {
      setAgents([])
    }
  }, [enabled, path, assignPool])

  useEffect(() => {
    void reload()
  }, [reload])

  return { agents, reload, path, assignPool }
}
